// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"_19YKgcY8CMyFWi3XwWzA1H"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/quickBetCard.css
// module id = 746
// module chunks = 0